import { parseNumber, parseAsCurrency } from "@frontend/utils";
const calculateUsdaFee = (options) => {
  const { feeFactor, baseLoanAmount, financedPortion, paidInCashPortion } = options;
  if (parseNumber(baseLoanAmount, 0) < 0) {
    throw new Error("Invalid base loan amount");
  }
  if (typeof feeFactor !== "number" || parseNumber(feeFactor, null) === null || parseNumber(feeFactor, 0) < 0) {
    throw new Error("Invalid fee factor");
  }
  let shouldDoDefaultCase = false;
  const areFinancedAndPaidInCashPortionsValidTypes = typeof financedPortion === "number" && parseNumber(financedPortion, null) !== null && parseNumber(financedPortion, 0) >= 0 && (typeof paidInCashPortion !== "number" && parseNumber(paidInCashPortion, null) === null || parseNumber(paidInCashPortion, 0) >= 0);
  shouldDoDefaultCase = !areFinancedAndPaidInCashPortionsValidTypes;
  if (areFinancedAndPaidInCashPortionsValidTypes) {
    const calculatedTotalFeeAmount2 = baseLoanAmount * feeFactor + financedPortion * feeFactor;
    const tolerance = 0.01;
    shouldDoDefaultCase = typeof paidInCashPortion === "number" && Math.abs(
      parseAsCurrency(calculatedTotalFeeAmount2) - (parseAsCurrency(financedPortion) + parseAsCurrency(paidInCashPortion))
    ) > tolerance;
  }
  shouldDoDefaultCase = shouldDoDefaultCase || Boolean(
    typeof financedPortion !== "number" || parseNumber(financedPortion, null) === null
  );
  if (shouldDoDefaultCase) {
    let calculatedDefaultFinancedPortion = Math.floor(
      parseAsCurrency(baseLoanAmount * feeFactor)
    );
    let calculatedDefaultPaidInCashFeeAmount = calculatedDefaultFinancedPortion % 1;
    do {
      const dollarsFromPaidInCashPortion = Math.floor(
        parseAsCurrency(
          calculatedDefaultPaidInCashFeeAmount + calculatedDefaultPaidInCashFeeAmount * feeFactor
        )
      );
      calculatedDefaultFinancedPortion += dollarsFromPaidInCashPortion;
      const newCalculatedTotalFinancedFeeAmount = baseLoanAmount * feeFactor + calculatedDefaultFinancedPortion * feeFactor;
      calculatedDefaultPaidInCashFeeAmount = newCalculatedTotalFinancedFeeAmount - calculatedDefaultFinancedPortion;
    } while (parseAsCurrency(calculatedDefaultPaidInCashFeeAmount) >= 1);
    return {
      feeFactor,
      baseLoanAmount,
      financedPortion: parseAsCurrency(calculatedDefaultFinancedPortion),
      paidInCashPortion: parseAsCurrency(calculatedDefaultPaidInCashFeeAmount)
    };
  }
  const calculatedTotalFeeAmount = baseLoanAmount * feeFactor + parseAsCurrency(financedPortion) * feeFactor;
  const newPaidInCashPortion = calculatedTotalFeeAmount - parseAsCurrency(financedPortion);
  return {
    feeFactor,
    baseLoanAmount,
    financedPortion: parseAsCurrency(financedPortion),
    paidInCashPortion: parseAsCurrency(newPaidInCashPortion)
  };
};
export {
  calculateUsdaFee
};
